export enum MarriageOfficialUpateTypes {
  name = 'name',
  data = 'data'
}
